import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { HSTSToast } from "../../utils/hstsToast";
import { SideBar } from "./inc/sideBar";
import { TopHeader } from "./inc/topHeader";
import { ToastContainer } from "react-toastify";
import {
  createProgress,
  uploadProgressFile,
} from "../../services/ProgressService";

const RegisterProgress = () => {
  const navigator = useNavigate();
  const { id } = useParams();
  const [step, setStep] = useState(1);

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const [progressData, setProgressData] = useState({
    previous: "",
    currently: "",
    next: "",
    documentPath: "",
    meetSupervisor: "",
    supervisorResponse: "",
    meetProgressPlan: "",
    submitThesis: "",
    studyComplition: "",
    challenges: "",
    suggestion: "",
    progressDate: new Date().toISOString().split("T")[0],
    progressStatus: "Pending",
  });

  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setSidebarOpen(false);
    }
  }, [windowWidth]);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const validateField = (name, value) => {
    let error = "";

    const requiredFieldsStep1 = [
      "previous",
      "currently",
      "next",
      "documentPath",
      "meetSupervisor",
      "supervisorResponse",
    ];

    const requiredFieldsStep2 = [
      "meetProgressPlan",
      "submitThesis",
      "studyComplition",
      "challenges",
      "suggestion",
    ];

    if (
      (step === 1 && requiredFieldsStep1.includes(name)) ||
      (step === 2 && requiredFieldsStep2.includes(name))
    ) {
      if (!value || value.trim() === "") {
        error = "This field is required.";
      }
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProgressData((prev) => ({ ...prev, [name]: value }));
    if (touched[name]) validateField(name, value);
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setProgressData((prev) => ({ ...prev, [name]: value }));
    setTouched((prev) => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      setProgressData((prev) => ({ ...prev, documentPath: file.name }));
      setTouched((prev) => ({ ...prev, documentPath: true }));
      validateField("documentPath", file.name);
    }
  };

  const handleNext = () => {
    const requiredFields = [
      "previous",
      "currently",
      "next",
      "documentPath",
      "meetSupervisor",
      "supervisorResponse",
    ];

    const newErrors = {};
    requiredFields.forEach((field) => {
      validateField(field, progressData[field]);
      if (!progressData[field] || progressData[field].trim() === "") {
        newErrors[field] = "This field is required.";
      }
    });

    setErrors(newErrors);
    setTouched((prev) => ({
      ...prev,
      ...Object.fromEntries(requiredFields.map((f) => [f, true])),
    }));

    if (Object.keys(newErrors).length === 0) {
      setStep(2);
    } else {
      HSTSToast("error", "Please fill all required fields.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredStep2 = [
      "meetProgressPlan",
      "submitThesis",
      "studyComplition",
      "challenges",
      "suggestion",
    ];

    const newErrors = {};
    requiredStep2.forEach((field) => {
      validateField(field, progressData[field]);
      if (!progressData[field] || progressData[field].trim() === "") {
        newErrors[field] = "This field is required.";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTouched((prev) => ({
        ...prev,
        ...Object.fromEntries(requiredStep2.map((f) => [f, true])),
      }));
      HSTSToast("error", "Please complete all required fields.");
      return;
    }

    const confirm = window.confirm(
      "Are you sure you want to submit this progress report? Once submitted, it cannot be modified."
    );

    if (!confirm) return;

    const payload = {
      ...progressData,
      studyId: parseInt(id),
      // studyId: { studyId: parseInt(id) },
    };

    try {
      const response = await createProgress(payload);
      const savedProgress = response.data;

      if (file) {
        await uploadProgressFile(savedProgress.progressId, file);
      }

      HSTSToast("success", "Progress submited successfully");
      // setTimeout(() => navigator("/student/study"), 1800);
      setTimeout(() => navigator(-1), 1800);
    } catch (error) {
      console.error("Submission error:", error);
      HSTSToast("error", "Submission failed, please try again");
    }
  };

  const getInputClass = (name) => {
    if (!touched[name]) return "form-control";
    return errors[name] ? "form-control is-invalid" : "form-control is-valid";
  };

  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="d-flex position-relative" style={{ minHeight: "100vh" }}>
        <SideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          activeMenu={activeMenu}
          toggleMenu={toggleMenu}
          windowWidth={windowWidth}
        />
        <div className="main-panel">
          <TopHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            windowWidth={windowWidth}
          />
          <div className="container mt-0">
            <div className="page-inner">
              <div className="page-header bg-white zis-shadow rounded-2 mt-2">
                <ul className="breadcrumbs my-md-3 mb-3 ms-0">
                  <li className="nav-home">
                    <Link to="/student" className="ps-3 ps-md-0">
                      <span className="fa fa-home"></span>
                    </Link>
                  </li>
                  <li className="separator">
                    <i className="fas fa-chevron-right text-secondary"></i>
                  </li>
                  <li className="nav-item text-black fw-semibold">
                    <Link to="/student/study">Study records</Link>
                  </li>
                  <li className="separator">
                    <i className="fas fa-chevron-right text-secondary"></i>
                  </li>
                  <li className="nav-item text-black fw-semibold">
                    <Link to="#">Add progress</Link>
                  </li>
                </ul>
              </div>

              <div className="row mt-5 align-items-center h-100">
                <form
                  className="col-lg-5 col-12 mx-auto"
                  onSubmit={
                    step === 2 ? handleSubmit : (e) => e.preventDefault()
                  }
                >
                  <div className="card zis-shadow rounded-3">
                    <div className="card-body">
                      <div className="text-center my-3">
                        <h1 className="h5 text-black fw-semibold">
                          {step === 1
                            ? "Progress Report – Step 1"
                            : "Progress Evaluation – Step 2"}
                        </h1>
                      </div>

                      {/* Step 1 */}
                      {step === 1 && (
                        <>
                          {[
                            { label: "Previous Progress", name: "previous" },
                            { label: "Current Progress", name: "currently" },
                            { label: "Next Month Progress", name: "next" },
                          ].map((field) => (
                            <div key={field.name} className="form-group mb-3">
                              <label>
                                {field.label}{" "}
                                <span className="text-danger fw-bold">*</span>
                              </label>
                              <textarea
                                name={field.name}
                                className={getInputClass(field.name)}
                                value={progressData[field.name]}
                                rows={3}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              {errors[field.name] && (
                                <div className="invalid-feedback">
                                  {errors[field.name]}
                                </div>
                              )}
                            </div>
                          ))}

                          <div className="form-group mb-3">
                            <label>
                              Current Progress Report (PDF){" "}
                              <span className="text-danger fw-bold">*</span>
                            </label>{" "}
                            <br />
                            <div className="text-secondary fw-bold mb-2">
                              Your report must be signed by supervisor / HOD and
                              stamped{" "}
                            </div>
                            <input
                              type="file"
                              className={getInputClass("documentPath")}
                              accept="application/pdf"
                              onChange={handleFileChange}
                              onBlur={handleBlur}
                            />
                            {errors.documentPath && (
                              <div className="invalid-feedback">
                                {errors.documentPath}
                              </div>
                            )}
                            {progressData.documentPath && (
                              <small className="text-muted">
                                Selected: {progressData.documentPath}
                              </small>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <div className="mb-2">
                              When did you meet or communicate with your
                              supervisor{" "}
                              <span className="text-danger fw-bold">*</span>
                            </div>
                            <input
                              type="date"
                              name="meetSupervisor"
                              className={getInputClass("meetSupervisor")}
                              value={progressData.meetSupervisor}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.meetSupervisor && (
                              <div className="invalid-feedback">
                                {errors.meetSupervisor}
                              </div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <div className="mb-2">
                              When did you receive last response from your
                              supervisor{" "}
                              <span className="text-danger fw-bold">*</span>
                            </div>
                            <input
                              type="date"
                              name="supervisorResponse"
                              className={getInputClass("supervisorResponse")}
                              value={progressData.supervisorResponse}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.supervisorResponse && (
                              <div className="invalid-feedback">
                                {errors.supervisorResponse}
                              </div>
                            )}
                          </div>

                          <div className="d-flex justify-content-end mb-3">
                            <button
                              type="button"
                              className="btn btn-primary rounded-2"
                              onClick={handleNext}
                            >
                              Next
                            </button>
                          </div>
                        </>
                      )}

                      {/* Step 2 */}
                      {step === 2 && (
                        <>
                          <div className="form-group mb-3">
                            <div className="mb-2">
                              Do you think your progress is going as you planned
                              .? <span className="text-danger fw-bold">*</span>
                            </div>
                            <div>
                              <label className="me-3">
                                <input
                                  type="radio"
                                  name="meetProgressPlan"
                                  value="YES"
                                  checked={
                                    progressData.meetProgressPlan === "YES"
                                  }
                                  onChange={handleRadioChange}
                                  onBlur={handleBlur}
                                />{" "}
                                Yes
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="meetProgressPlan"
                                  value="NO"
                                  checked={
                                    progressData.meetProgressPlan === "NO"
                                  }
                                  onChange={handleRadioChange}
                                  onBlur={handleBlur}
                                />{" "}
                                No
                              </label>
                            </div>
                            {errors.meetProgressPlan && (
                              <div className="text-danger small mt-1">
                                {errors.meetProgressPlan}
                              </div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <div className="mb-2">
                              When do you expect to submit Thesis / Dissertation{" "}
                              <span className="text-danger fw-bold">*</span>
                            </div>
                            <input
                              type="date"
                              name="submitThesis"
                              className={getInputClass("submitThesis")}
                              value={progressData.submitThesis}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.submitThesis && (
                              <div className="invalid-feedback">
                                {errors.submitThesis}
                              </div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <label>
                              Select study completion date{" "}
                              <span className="text-danger fw-bold">*</span>
                            </label>
                            <input
                              type="date"
                              name="studyComplition"
                              className={getInputClass("studyComplition")}
                              value={progressData.studyComplition}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.studyComplition && (
                              <div className="invalid-feedback">
                                {errors.studyComplition}
                              </div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <label>
                              Challenges encountered{" "}
                              <span className="text-danger fw-bold">*</span>
                            </label>
                            <textarea
                              name="challenges"
                              className={getInputClass("challenges")}
                              value={progressData.challenges}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.challenges && (
                              <div className="invalid-feedback">
                                {errors.challenges}
                              </div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <label>
                              Suggestions{" "}
                              <span className="text-danger fw-bold">*</span>
                            </label>
                            <textarea
                              name="suggestion"
                              className={getInputClass("suggestion")}
                              value={progressData.suggestion}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.suggestion && (
                              <div className="invalid-feedback">
                                {errors.suggestion}
                              </div>
                            )}
                          </div>

                          <div className="d-flex justify-content-between mb-4">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => setStep(1)}
                            >
                              Back
                            </button>
                            <button type="submit" className="btn btn-success">
                              Save
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default RegisterProgress;
